import { mutator } from "satcheljs";
import { resetShiftStore, ShiftStore } from "sh-shift-store";

export default mutator(resetShiftStore, function resetShiftStore() {
    ShiftStore().shifts.clear();
    ShiftStore().shiftIdsByDateAndMember.clear();
    ShiftStore().shiftsCacheStartTime = null;
    ShiftStore().shiftsCacheEndTime = null;
});
